// eslint-disable-next-line import/prefer-default-export
export const SHIPMENT_ = 'SHIPMENT_';
export const FEE_SERVICE = 'FEE_SERVICE';
export const ITEM = 'ITEM';

export const ORDERING_STRATEGY = {
  single: 'SINGLE',
  sequential: 'SEQUENTIAL',
};

export const USER_RETURN_TYPE = {
  RETURNING: 'returning',
  NEW: 'new',
};

export const USER_ROLE = {
  BUYER: 'buyer',
  SELLER: 'seller',
};

export const USER_TYPE = {
  PRIVATE: 'PRIVATE',
  BUSINESS: 'BUSINESS',
};

export const SHIPMENT_OPERATORS = {
  INPOST: 'INPOST',
  POCZTA: 'POCZTA',
  RUCH: 'RUCH',
} as const;
export type CurrentServicePointOperator = typeof SERVICE_POINT_OPERATOR;

export const PACKAGE_SIZE = {
  S: 'S',
  M: 'M',
  XL: 'XL',
  XXL: 'XXL',
} as const;

export const PACKAGE_DIMENSION = {
  S: '8x38x64',
  M: '19x38x64',
  XL: '41x38x64',
  XXL: '60x60x70',
} as const;

export const PACKAGE_WEIGHT = {
  '0-5': '5',
  '5-20': '20',
  '< 25': '25',
} as const;

export const SHIPMENT_PRICE_CODE = 'shipment-price';

export const PAYMENT_METHODS = {
  cod: 'cod',
  marketpay: 'marketpay',
} as const;

export const SERVICE_POINT_OPERATOR = {
  poczta: 'poczta',
  inpost: 'inpost',
  ruch: 'ruch',
} as const;

export const ERROR_MESSAGES = {
  length: 'dlv_validation_length',
  minLength: 'dlv_validation_min_length',
  email: 'dlv_validation_email',
  phoneAreaCode: 'dlv_validation_phone_area',
  phone: 'dlv_validation_phone',
  postalCode: 'dlv_validation_postalCode',
  postCode: 'dlv_validation_postcode',
  userPostCode: 'dlv_user_postcode',
  vatNumberLength: 'dlv_validation_vatnumber',
  vatNumberFormat: 'dlv_service_fee_request_invoice_vat_error_format',
  validationRequired: 'dlv_validation_required',
  patternMatch: 'dlv_validation_match',
};

export const EXTERNAL_LINKS = {
  SAFE_DEAL_TERMS:
    'https://pomoc.olx.pl/hc/pl/articles/360016316399-Załącznik-nr-8-Pakiet-Ochronny-OLX',
  SAFE_DEAL_TERMS_EXTENDED:
    'https://pomoc.olx.pl/olxplhelp/s/article/załącznik-nr-8-pakiet-ochronny-olx-V20-olx',
};

export const FIELD_NAMES = {
  firstName: 'firstName',
  lastName: 'lastName',
  companyName: 'companyName',
  company: 'company',
  email: 'email',
  phoneNumber: 'phoneNumber',
  streetName: 'streetName',
  streetNumber: 'streetNumber',
  apartmentNumber: 'apartmentNumber',
  postCode: 'postCode',
  city: 'city',
  countryCode: 'countryCode',
  vatNumber: 'vatNumber',
};

export const shortCheckoutInputs = [
  FIELD_NAMES.email,
  FIELD_NAMES.firstName,
  FIELD_NAMES.lastName,
  FIELD_NAMES.company,
  FIELD_NAMES.phoneNumber,
];

export const PSP_TYPE = {
  PAYU: 'PAYU',
  ADYEN: 'ADYEN',
};

export const API_ERROR_CODES = {
  NOT_EMPTY: 'NOT_EMPTY',
  MAX_LENGTH: 'MAX_LENGTH',
  INVALID_FORMAT: 'INVALID_FORMAT',
  POSTCODE_NOT_SUPPORTED: 'POSTCODE_NOT_SUPPORTED',
  INVALID_ISO_COUNTRY_CODE: 'INVALID_ISO_COUNTRY_CODE',
};

export const LQ_FLAG = {
  PREFILL_CONSENT_SUMMARY: 'do-2963',
  OMNIBUS_HISTORICAL_LOWEST: 'do-3347',
};

export const FORM_WIDTH = '923px';

export const INVOICE_FOR = {
  DELIVERY_FEE: 'DELIVERY_FEE',
  SELLER_FEE: 'SELLER_FEE',
};
